import { MdCircle } from 'react-icons/md';
import { IconType } from 'react-icons';

interface ModeItemProps {
    modeKey: string;
    modeName: string;
    icon: IconType;
    isSelected: boolean;
    tooltipContent: string;
    onModeChange: (mode: string) => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    getItemBackground: (mode: string) => string;
    showBorder?: boolean;
}

const ModeItem = ({
    modeKey,
    modeName,
    icon: Icon,
    isSelected,
    tooltipContent,
    onModeChange,
    onMouseEnter,
    onMouseLeave,
    getItemBackground,
    showBorder = false
}: ModeItemProps) => {
    return (
        <li
            onClick={() => onModeChange(modeKey)}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            className={`p-2 text-sm cursor-pointer text-black dark:text-white flex justify-between items-center ${getItemBackground(modeKey)} ${showBorder ? 'border-t border-neutral-600' : ''}`}
            data-tooltip-id="main-tooltip"
            data-tooltip-content={tooltipContent}
            data-tooltip-place="right"
            data-tooltip-delay-show={250}
        >
            <div className="flex items-center">
                <Icon size={16} className="mr-2" />
                {modeName}
            </div>
            {isSelected && <MdCircle size={11} className="text-cyan-600 dark:text-cyan-500" />}
        </li>
    );
};

export default ModeItem;